import type { GateKind, PatientApplicability } from './types';

/** Display metadata for each gate kind. Subject-neutral; sections inject
 * patient/client wording via useSubjectLanguageVariants where needed. */
export const GATE_KIND_META: Record<
  GateKind,
  { label: string; description: string }
> = {
  paperwork: {
    label: 'Forms',
    description: 'Require a form to be completed while booking.',
  },
  card: {
    label: 'Card on file',
    description: 'Require a saved payment card before a booking can be submitted.',
  },
  eligibility: {
    label: 'Insurance eligibility',
    description: 'Check insurance coverage during booking.',
  },
  fit: {
    label: 'Good-fit screening',
    description: 'Screen for fit before showing the calendar.',
  },
};

export const APPLIES_TO_OPTIONS: PatientApplicability[] = [
  'new',
  'returning',
  'all',
];
